import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { useInterval } from 'utils/hooks/useInterval';
import { PrimaryButton, DefaultButton, Dialog, Typography } from '@beeline.com/bp-design-system';
import { PageTitle } from '../header/PageTitle';
import { useTimeoutDialogIntl } from './translations/useTimeoutDialogIntl';
interface TimeoutOutDialogProps {
  promptTimeout?: Milliseconds;
  handleLogout: () => void;
  handleCancelLogout: () => void;
}
const duration = 1000;
export const TimeoutDialog: FC<React.PropsWithChildren<TimeoutOutDialogProps>> = ({
  handleLogout,
  handleCancelLogout,
  promptTimeout = 30000
}) => {
  const [remainingSeconds, setRemainingSeconds] = useState(promptTimeout / 1000);
  const intl = useTimeoutDialogIntl();
  useInterval(() => {
    if (remainingSeconds <= 0) {
      handleLogout();
    } else {
      setRemainingSeconds(remainingSeconds - 1);
    }
  }, duration);
  return (
    <Dialog disableBackdropClick open onClose={() => {}}>
      <PageTitle title={intl.headTitle({ seconds: remainingSeconds })} dynamicTitle />
      <StyledTimeoutDialog>
        <Typography variant="h3">{intl.title}</Typography>
        <Typography>{intl.descriptionWithRemainingSeconds({ seconds: remainingSeconds })}</Typography>
        <div className="actions">
          <DefaultButton.Contained dataTest="logout" onClick={handleLogout}>
            {intl.logout}
          </DefaultButton.Contained>
          <PrimaryButton.Contained dataTest="stay" onClick={handleCancelLogout}>
            {intl.stay}
          </PrimaryButton.Contained>
        </div>
      </StyledTimeoutDialog>
    </Dialog>
  );
};
const StyledTimeoutDialog = styled.div`
  > div {
    padding-bottom: 1rem;
    &.actions {
      padding-bottom: 0;
    }
  }
  .actions {
    display: flex;
    justify-content: space-between;
  }
`;
